import React, { useContext, useEffect, useRef, useState } from "react";

import { Controller, useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import { useParams } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import { toastWarning } from "../../../../shared/helpers";

import { DarkSelectInput } from "../../../atoms/Inputs";
import { P } from "../../../atoms/Texts";

import ActionPageHero from "../../../molecules/ActionPageHero";

import { selectStyle } from "../../../../shared/fixtures/select_style";
import { PrimaryButton } from "../../../atoms/Buttons";

import CreateSuccessModal from "../../../organisms/CreateSuccessModal";
import situation from "../../../../shared/fixtures/situation";
import { demoContext } from "../../../../shared/store/contexts";

const AddEligibilityPage = () => {
  const { id } = useParams();
  const { services: data } = useContext(demoContext);

  const arrangeServices = (services) => {
    let _services = [];
    services.forEach((service) => {
      _services.push({
        label: service.name,
        value: service.id,
      });
    });
    return _services;
  };

  const [services, setServices] = useState([]);

  useEffect(() => {
    if (data) {
      setServices(arrangeServices(data));
    }
    return () => {
      setServices([]);
    };
  }, [data]);

  const loader = useRef(null);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors: formStateErrors },
  } = useForm();

  const [submitted] = useState(false);

  const submitForm = (data) => {
    toastWarning("Cannot perform this action on Demo mode");
  };

  return (
    <main className="flex flex-col w-full relative">
      <LoadingBar height={2} color="#00AF72" ref={loader} />
      <div className="flex justify-between items-center">
        <ActionPageHero
          className="organization-container"
          title="Add Eligibility Criteria"
          description="Add new human situations category that a program serves"
          back
          goBackText="Back to All Eligibility Criteria"
        />
      </div>
      <section className="organization-container pb-10 flex-grow flex flex-col mt-6">
        <form onSubmit={handleSubmit(submitForm)} className="md:w-3/5">
          <div className="flex flex-col lg:flex-no-wrap">
            <div className="mb-6">
              <label htmlFor="services">
                <P
                  fontSize="14px"
                  fontFamily="semi"
                  color="#47495C"
                  className="mb-2"
                >
                  Services
                  <span
                    className=""
                    style={{
                      color: "#E62250",
                    }}
                  >
                    *
                  </span>
                </P>
              </label>
              <Controller
                control={control}
                id="services"
                name="services"
                render={({ field }) => (
                  <Select
                    {...field}
                    styles={selectStyle}
                    autoComplete="true"
                    options={services}
                    isMulti
                    placeholder="--Add a service--"
                    className="w-full"
                  />
                )}
                rules={{
                  required: true,
                  validate: (value) => Array.isArray(value) && value.length > 0,
                }}
                defaultValue={[]}
              />
              {formStateErrors.services && (
                <P fontSize="12px" className="mt-2 mb-2 text-red-400 text-sm">
                  Select a service
                </P>
              )}
            </div>

            <div className="mb-6">
              <label htmlFor="situation">
                <P
                  fontSize="14px"
                  fontFamily="semi"
                  color="#47495C"
                  className="mb-2"
                >
                  Situations
                  <span
                    className=""
                    style={{
                      color: "#E62250",
                    }}
                  >
                    *
                  </span>
                </P>
              </label>
              <Controller
                control={control}
                id="situation"
                name="situation"
                render={({ field }) => (
                  <CreatableSelect
                    {...field}
                    styles={selectStyle}
                    isMulti
                    autoComplete="true"
                    options={situation}
                    placeholder="-- Add Situations --"
                    className="w-full"
                  />
                )}
                rules={{
                  required: true,
                  validate: (value) => Array.isArray(value) && value.length > 0,
                }}
                // defaultValue={{
                //   label: findOption(situation)?.label,
                //   value: findOption(situation)?.value,
                // }}
              />
              {formStateErrors.situation && (
                <P fontSize="12px" className="mt-2 mb-2 text-red-400 text-sm">
                  Enter at least one situation
                </P>
              )}
            </div>

            <div className="">
              <DarkSelectInput
                type="select"
                id="autoScreen"
                name="autoScreen"
                placeholder=""
                label="Auto Screen Participants?"
                defaultValue=""
                required
                {...register("autoScreen", {
                  required: "Select a screen preference",
                })}
              >
                <option value="" disabled>
                  Select an option
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </DarkSelectInput>

              <ErrorMessage
                errors={formStateErrors}
                name="autoScreen"
                as={
                  <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />
                }
              >
                {({ messages }) =>
                  messages &&
                  Object.entries(messages).map(([type, message]) => (
                    <P key={type}>{message}</P>
                  ))
                }
              </ErrorMessage>
            </div>
            <PrimaryButton type="submit" className="">
              Save
            </PrimaryButton>
          </div>
        </form>
      </section>
      {submitted && (
        <CreateSuccessModal
          title="Success"
          message="New eligibility data has been added."
          backText="Close"
          closeModal={() =>
            (window.location.pathname = `/dashboard/organization/${id}/eligibility`)
          }
        />
      )}
    </main>
  );
};

export default AddEligibilityPage;
